import React, { useEffect, useRef, useState } from 'react';
import { usePrefersReducedMotion, useMediaQuery } from '@/lib/hooks';

export const CustomCursor = () => {
  const reduced = usePrefersReducedMotion();
  const fine = useMediaQuery('(pointer: fine)');
  const wide = useMediaQuery('(min-width: 1024px)');
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const [label, setLabel] = useState('');
  const [active, setActive] = useState(false);

  const enabled = fine && wide && !reduced;

  useEffect(() => {
    if (!enabled) {
      document.body.classList.remove('cursor-on');
      return;
    }
    document.body.classList.add('cursor-on');

    const mouse = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    const ring = { x: mouse.x, y: mouse.y };
    let raf;

    const onMove = (e) => {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (dotRef.current) {
        dotRef.current.style.transform = `translate(${mouse.x}px, ${mouse.y}px)`;
      }
      const target = e.target.closest('[data-cursor]');
      if (target) {
        setLabel(target.getAttribute('data-cursor'));
        setActive(true);
      } else {
        setActive(false);
        setLabel('');
      }
    };

    const loop = () => {
      ring.x += (mouse.x - ring.x) * 0.18;
      ring.y += (mouse.y - ring.y) * 0.18;
      if (ringRef.current) {
        ringRef.current.style.transform = `translate(${ring.x}px, ${ring.y}px)`;
      }
      raf = requestAnimationFrame(loop);
    };
    loop();
    window.addEventListener('mousemove', onMove);
    return () => {
      window.removeEventListener('mousemove', onMove);
      cancelAnimationFrame(raf);
      document.body.classList.remove('cursor-on');
    };
  }, [enabled]);

  if (!enabled) return null;

  return (
    <div aria-hidden='true' data-testid='custom-cursor'>
      <div
        ref={dotRef}
        style={{ position: 'fixed', top: 0, left: 0, zIndex: 9999, pointerEvents: 'none' }}
      >
        <div style={{ transform: 'translate(-50%, -50%)', width: 6, height: 6, borderRadius: '50%', background: '#B88A3B' }} />
      </div>
      <div
        ref={ringRef}
        style={{ position: 'fixed', top: 0, left: 0, zIndex: 9998, pointerEvents: 'none' }}
      >
        <div
          style={{
            transform: 'translate(-50%, -50%)',
            transition: 'width 0.3s cubic-bezier(0.22,1,0.36,1), height 0.3s cubic-bezier(0.22,1,0.36,1), background 0.3s',
            width: active ? 64 : 34,
            height: active ? 64 : 34,
            borderRadius: 999,
            border: '1px solid rgba(184,138,59,0.7)',
            background: active ? 'rgba(7,91,97,0.85)' : 'transparent',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {active && label ? (
            <span style={{ color: '#F6F5F1', fontSize: 9, letterSpacing: '0.12em', fontFamily: 'var(--font-mono)', textTransform: 'uppercase' }}>{label}</span>
          ) : null}
        </div>
      </div>
    </div>
  );
};
